import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateProfile } from '../../../redux/profile/action';

export default function Availability({ profile }) {
    const dispatch = useDispatch();

    const working_days = [
        { id: 0, day: 'Sunday' },
        { id: 1, day: 'Monday' },
        { id: 2, day: 'Tuesday' },
        { id: 3, day: 'Wednesday' },
        { id: 4, day: 'Thursday' },
        { id: 5, day: 'Friday' },
        { id: 6, day: 'Saturday' },
    ];

    const initialActiveDays = profile?.preferences?.working_days
        ? profile.preferences.working_days.split(',').map(day => parseInt(day))
        : [];

    const [activeDays, setActiveDays] = useState(initialActiveDays);

    const toggleDay = (dayId) => {
        setActiveDays(prevActiveDays => {
            const newActiveDays = prevActiveDays.includes(dayId)
                ? prevActiveDays.filter(id => id !== dayId)
                : [...prevActiveDays, dayId];
            return newActiveDays;
        });
    };

    const updateHours = () => {
        const data = {
            type: "preferences",
            preferences: {
                working_days: activeDays.join(','),
            },
        };
        dispatch(updateProfile(data));
    };

    useEffect(() => {
        setActiveDays(initialActiveDays);
    }, [profile]);

    const hasChanges = JSON.stringify(activeDays) !== JSON.stringify(initialActiveDays);

    return (
        <>
            <h4 className='availability-head'>Availability</h4>
            <div className='d-flex justify-content-between align-items-center'>
                <div>
                    <h5 className="mb-0">Working Days</h5>
                    <p>Select your working hour</p>
                </div>
                {hasChanges && (
                <button
                    
                    onClick={updateHours}
                    className="buttons background-button"
                >
                    Save Changes
                </button>
            )}

            </div>


            
            <div className="working-days">
                {working_days.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => toggleDay(item.id)}
                        className={`days ${activeDays.includes(item.id) ? 'active' : ''}`}
                    >
                        <h6>{item.day}</h6>
                    </div>
                ))}
            </div>
        </>
    );
}
